import { branch } from 'recompose'
import WizardProvider from './WizardProvider'
import WizardClient from './WizardClient'

const WizardContainer = branch(
  ({ provider }) => !provider,
  WizardClient,
  WizardProvider
)

export default WizardContainer
